import React from 'react'
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface ActiveDashboardState {
    /** UUID of dashboard that should be currently displayed or what will show if redirecting to the root */
    id: string
}

export const useActiveDashboardIdStore = create<ActiveDashboardState>()(
    devtools(
        persist(
            (set) => ({
                id: '',
            }),
            { name: 'edge-active-dashboard-id' },
        ),
        { name: 'ActiveDashboardIdStore' },
    ),
)

export const useActiveDashboardId = () => useActiveDashboardIdStore((state) => state.id)
export const getActiveDashboardId = () => useActiveDashboardIdStore.getState().id
export const setActiveDashboardId = (id: string) => useActiveDashboardIdStore.setState({ id })
export const useIsActiveDashboard = (id: string) =>
    useActiveDashboardIdStore(React.useCallback((state) => state.id === id, [id]))
